<div class="partner-capital-horizontal">
  <div class="partner-capital-horizontal-body">
    <mat-accordion multi="true">

      <ng-container *ngFor="let partnerCapitalData of partCapitalHorizontalDetails">
        <mat-expansion-panel [expanded]="horozontalPanelsState">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{partnerCapitalData.fullyear | date: 'y'}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="partner-capital-horizontal-body-details">
            <table class="partner-capital-table">
              <thead>
                <tr class="partner-capital-table-header">
                  <th class="th-desc">
                    <div class="th-col-desc">Description</div>
                  </th>
                  <th *ngFor="let header of partnerCapitalData.partnerlist">
                    <div class="th-col-partner" title="{{header.partnername}}">
                      {{header.partnername}}
                    </div>
                    <div class="th-col-partner" title="{{header.allocationtypevalue}}">{{header.allocationtypevalue}}</div>
                  </th>
                  <th class="th-year">
                    <div class="th-col-year" title="{{partnerCapitalData.fullyear | date: 'MMMM d'}}">{{partnerCapitalData.fullyear | date: 'MMMM d'}}</div>
                    <div class="th-col-year" title="{{partnerCapitalData.fullyear | date: 'y'}}">{{partnerCapitalData.fullyear | date: 'y'}}</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="partnerCapitalData.body">
                  <tr class="partner-capital-table-details"
                    *ngFor="let bodyData of partnerCapitalData.body;let des=index">
                      <!-- DESCRIPTION -->
                      <td class="td-desc">
                        <div class="actions">
                          <div class="status" *ngIf="bodyData.issource == 1 else oldBlock">
                            <span class="col-partner-status">
                              <span class="sts-label">NEW</span>
                            </span>
                          </div>
                          <ng-template #oldBlock>
                            <div class="status"><span class="col-partner-status"></span></div>
                          </ng-template>
                          <div class="hover-items" *ngIf="!bodyData.isAdd">
                            <button mat-icon-button class="more-btn" [matMenuTriggerFor]="cfmenu" aria-label=""
                              #t="matMenuTrigger" (click)="$event.stopPropagation()">
                              <i class="fa-regular fa-ellipsis-vertical more-actions"></i>
                            </button>
                            <mat-menu #cfmenu="matMenu" class="pc-horizontal" #afterMenu="matMenu" xPosition="after">
                              <button title="Add Row" mat-menu-item class="add-row-btn"
                                (click)="insertData(partnerCapitalData.body, des, partnerCapitalData.fullyear);">
                                <i class="fa-regular fa-rectangle-history-circle-plus add-row"></i>
                                <span>Add Row</span>
                              </button>
                              <!-- <button mat-menu-item class="add-row-btn" (click)="bodyData.isEdit=true;bodyData.isAdded=true"> solution for binding two span at a time error  -->
                              <!-- <button mat-menu-item class="add-row-btn"
                                (click)="bodyData.isEdit=true;bodyData.isAdded=true">
            <i class="fa-regular fa-pen"></i>
                                <span>Edit</span>
                              </button> -->
                              <button title="Edit" mat-menu-item class="add-row-btn"
                                (click)="editData(partnerCapitalData.body, des, partnerCapitalData.fullyear,bodyData);bodyData.isEdit=true;">
                                <i class="fa-regular fa-pen"></i>
                                <span>Edit</span>
                              </button>
                              <button title="Delete" mat-menu-item class="add-row-btn" *ngIf="bodyData.issource == 1" (click)="delete(partnerCapitalData.body, des, partnerCapitalData.fullyear)">
                                <i class="fa-regular fa-trash-can add-row"></i>
                                <span>Delete</span>
                              </button>
                            </mat-menu>
                          </div>
                        </div>
                        <div class="td-col-desc flex-box-vc-hl" title="{{bodyData.linenamechange}}">
                          <p class="ellipse no-marg">
                            <span *ngIf="!bodyData.isEdit">{{bodyData.linenamechange}}</span>
                          </p>
                          <span *ngIf="bodyData.partnershiplineitemid==0|| bodyData.isEdit">
                            <input type="text" class="pc-text" [(ngModel)]="bodyData.linenamechange" autocomplete="off">
                          </span>
                        </div>
                      </td>
                      <!-- Pratners List -->
                      <td *ngFor="let partnerData of bodyData.partners_list.partners_list">
                        <div class="td-col-partner flex-box-vc-hr" title="{{partnerData.amount}}">
                          <p class="ellipse no-marg">
                            <span *ngIf="!bodyData.isEdit">{{partnerData.amount}}</span>
                          </p>
                          <span *ngIf="bodyData.partnershiplineitemid==0||bodyData.isEdit"> <input type="text"
                              class="pc-text" [(ngModel)]="partnerData.amount" autocomplete="off" (keypress)="onlyNumberKey($event)" style="position: relative; z-index: 0;text-align: right"></span>
                        </div>
                      </td>
                      <!-- Year -->
                      <td class="td-year">
                        <div class="editable">
                          <div class="td-col-year flex-box-vc-hr" title="{{bodyData.yearamount}}">
                            <p class="ellipse no-marg">
                              <span >{{bodyData.yearamount}}</span>
                            </p>
                            <!-- <span *ngIf="bodyData.partnershiplineitemid==0 || bodyData.isEdit"> <input type="text"
                                class="pc-text" [(ngModel)]="bodyData.yearamount" [readonly]="true" title="Not Editable"></span> -->
                          </div>
                          <div class="pc-cls-ok" *ngIf="bodyData.partnershiplineitemid==0 || bodyData.isEdit">
                                <button mat-button class="button-text pc-icon" title="Close" (click)="clearAddedRow(partnerCapitalData.body,des,bodyData);">
                                    <i class="fa-regular fa-xmark"></i>
                                </button>
                                <button mat-button class="button-text pc-icon" title="Save" (click)="saveRow(bodyData)">
                                    <i class="fa-regular fa-check pc-icon"></i>
                                </button>
                          </div>
                        </div>
                      </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </div>
</div>
<ng-template #confirmDelete>
  <div class="pd-dialog-delete">
    <div class="dialogboxheader">
      <div class="flex-box header-title">
        <h1 mat-dialog-title dialogbox class="flex-box no-marg">
            <i class="fa-regular fa-triangle-exclamation warning-msg"></i>
          <span>Delete</span>
        </h1>
      </div>
      <button class="transparent-btn float-right " [mat-dialog-close]>
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div class="delete-content">
      <p class="dialogbox">You are trying to delete.</p>
      <p class="dialogbox">Do you want to continue?</p>
    </div>
    <div mat-dialog-actions>
      <div class="pd-delete-dialog-actions unap-yes-no">
        <button mat-flat-button mat-stroked-button class="float-left yesno-btn mar-r-16" color="secondary" [mat-dialog-close]>
          No
        </button>
        <button mat-flat-button class="float-right yesno-btn" color="primary" [mat-dialog-close]
                (click)="saveRow(addRow)">
          Yes
        </button>
      </div>
    </div>
  </div>
</ng-template>
